"use client"

import {
  useStyle 
} from "@/classify"
import "swiper/components/pagination/pagination.min.css"
import SwiperCore, {
  Pagination 
} from "swiper/core"
import {
  Swiper, SwiperSlide 
} from "swiper/react"
import "swiper/swiper-bundle.css"
import banner from "../../assets/images/keep-dry-and-warm/banner.webp"
import banner_m from "../../assets/images/keep-dry-and-warm/banner_m.webp"
import SimpleImage from "../Image/simpleImage"
import defaultClasses from "./keepDryAndWarmPage.module.css"
import mySwiperClasses from "./mySwiper.module.css"

// install Swiper modules
SwiperCore.use([Pagination])

import {
  useWindowSize 
} from "@/common/hooks/useWindowSize"

const MobileSwiper = () => {
  const classes = useStyle(mySwiperClasses)

  return (
    <section className={classes.reviews}>
      <Swiper
        spaceBetween={30}
        pagination={{
          clickable: true,
        }}
        className={classes.mySwiper}
      >
        <SwiperSlide className={classes.mySwiperSlide}>
          <section>
            <h5 className='name'>Christy Pegram</h5>
            <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
            <span>
                            Boots are awesome and price was fantastic!{" "}
              <em>
                <i>Keeps feet dry</i> from water and muck!
              </em>
                            Purchased these for my teenage son that is avid
                            hunter and these work perfect. I would highly
                            recommend the boots. Great Boots for an amazing
                            price!
            </span>
            <a href='https://www.hisea.com/fishingsir-pvc-waterproof-waders.html'>
                            View Review
            </a>
          </section>
          <section>
            <h5 className='name'>Lauren</h5>
            <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
            <span>
                            Wore these elk hunting this season and I'm glad I
                            did. They were{" "}
              <em>
                                comfortable to walk around in and{" "}
                <i>kept my feet quite warm.</i>
              </em>{" "}
                            I could walk on thorny branches, step in water and
                            mud and my feet stayed dry and clean. Thanks Hisea
                            for a great product! Will definitely use these
                            hunting every year!
            </span>
            <a href='https://www.hisea.com/hisea-outdoor-hunting-boots-mid-calf-rain-boots.html'>
                            View Review
            </a>
          </section>
        </SwiperSlide>
        <SwiperSlide className={classes.mySwiperSlide}>
          <section>
            <h5 className='name'>Deniset</h5>
            <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
            <span>
                            I got the boots to work outside and pull weeds down
                            by my lake and work in the garden. They are true to
                            size,{" "}
              <em>
                                extremely comfortable and{" "}
                <i>keep my feet dry.</i>
              </em>{" "}
                            They are easy to clean and I love the style.
                            Definitely worth the money.
            </span>
            <a href='https://www.hisea.com/women-ankle-height-garden-boots-xsx30w.html'>
                            View Review
            </a>
          </section>
          <section>
            <h5 className='name'>Ambert</h5>
            <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
            <span>
                            These boots are really nice. Very high quality and
                            well made.{" "}
              <em>
                                They keep my feet <i>warm and dry</i> while
                                outside in the rain.
              </em>{" "}
                            They have decent grip on the bottom to help not
                            slide. They clean easily as well. I would recommend
                            it.
            </span>
            <a href='https://www.hisea.com/womens-rubber-mud-boots-xsx22w.html'>
                            View Review
            </a>
          </section>
        </SwiperSlide>
        <SwiperSlide className={classes.mySwiperSlide}>
          <section>
            <h5 className='name'>Jared S.</h5>
            <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
            <span>
                            These boots are extremely comfortable! The cushions
                            in the inside sole feels like walking on a soft
                            pillow. I love the strap on the back for adjusting
                            the tightness. I can wear my jeans inside without
                            bunching up while walking.I am a farmer so I'm out
                            in the pasture and muck most of my day.{" "}
              <em>
                                These boots clean up very nicely. They seem to
                                be very durable and{" "}
                <i>keep my feet warm and dry.</i>
              </em>
            </span>
            <a href='https://www.hisea.com/mens-rubber-working-boots-with-eva-midsoles-xsx26.html'>
                            View Review
            </a>
          </section>
          <section>
            <h5 className='name'>MJ</h5>
            <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
            <span>
                            These boots are insulated and 100% waterproof and
                            breathable and light weight and slip-resistant.
                            Also, they are a very good looking pair of boots.
                            The stretch-fit top bindings the calves to{" "}
              <em>
                <i>keep warmth</i> in and cold out.
              </em>{" "}
                            My husband loves these boots. He would highly
                            recommend them and I think they are a good buy!
            </span>
            <a href='https://www.hisea.com/mens-rubber-working-boots-with-eva-midsoles-xsx26.html'>
                            View Review
            </a>
          </section>
        </SwiperSlide>
      </Swiper>
    </section>
  )
}

const KeepDryAndWarmPage = (props) => {
  const classes = useStyle(defaultClasses, props.classes)

  const windowSize = useWindowSize()

  const isMobile = windowSize.innerWidth <= 640

  return (
    <div className={classes.root}>
      <div className={classes.banner}>
        <SimpleImage
          alt='banner'
          classes={{
            image: classes.image,
            root: classes.imageContainer,
          }}
          src={isMobile ? banner_m.src : banner.src}
        />
      </div>
      <div className={classes.videoContainer}>
        <h2 className={classes.videoTitle}>
                    100% KEEP DRY & WARM WITH A 100-YEAR WARRANTY
        </h2>
        <p className={classes.videoDesc}>
                    100% keep dry and warm is not just a slogan, it's a
                    guarantee from us and our confidence comes from the quality
                    our products presents.
        </p>
        <p className={classes.videoDesc}>
                    To ensure you could feel 100% free to try our products, we
                    also provide a 100-year warranty which makes it an easy
                    decision for you. Try us! You won't be disappointed!
        </p>

        <iframe
          className={classes.video}
          type='text/html'
          width='640'
          height='360'
          src='https://www.youtube-nocookie.com/embed/lDfRFxFpcQM'
        />
      </div>

      <div className={classes.featuresContainer}>
        <section className={classes.wordSection}>
          <h2>100% Keep Dry</h2>
          <span>
                        We use 2mm H-Air Mesh lining and our wick technology to
                        move sweat away from your feed to keep your feet dry all
                        the day.
          </span>
          <a href='https://www.hisea.com/mens-boots/product_list_order/best_seller/ '>
                        Shop Men`s Best Sellers
          </a>
        </section>
        <section className={classes.secondSection}>
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/keepdar.webp'
            alt='keep dar'
          />
        </section>
        <section>
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/keepwarm.webp'
            alt='keep warm'
          />
        </section>
        <section className={classes.wordSection}>
          <h2>100% Keep Warm</h2>
          <span>
                        We use Flex-Foam neoprene to provide 100% waterproof
                        with comfort, flexibility, shock absoption and heat
                        retention properties.
          </span>
          <a href='https://www.hisea.com/womens-boots/product_list_order/best_seller/'>
                        Shop Women`s Best Sellers
          </a>
        </section>
      </div>

      <div className={classes.reviewContainer}>
        <h2>WHAT OUR CUSTOMERS SAID</h2>

        {isMobile ? (
          <MobileSwiper />
        ) : (
          <section className={classes.reviews}>
            <section>
              <h5 class='name'>Christy Pegram</h5>
              <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
              <span>
                                Boots are awesome and price was fantastic!{" "}
                <em>
                  <i>Keeps feet dry</i> from water and muck!
                </em>
                                Purchased these for my teenage son that is avid
                                hunter and these work perfect. I would highly
                                recommend the boots. Great Boots for an amazing
                                price!
              </span>
              <a href='https://www.hisea.com/fishingsir-pvc-waterproof-waders.html'>
                                View Review
              </a>
            </section>
            <section>
              <h5 class='name'>Lauren</h5>
              <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
              <span>
                                Wore these elk hunting this season and I'm glad
                                I did. They were{" "}
                <em>
                                    comfortable to walk around in and{" "}
                  <i>kept my feet quite warm.</i>
                </em>{" "}
                                I could walk on thorny branches, step in water
                                and mud and my feet stayed dry and clean. Thanks
                                Hisea for a great product! Will definitely use
                                these hunting every year!
              </span>
              <a href='https://www.hisea.com/hisea-outdoor-hunting-boots-mid-calf-rain-boots.html'>
                                View Review
              </a>
            </section>
            <section>
              <h5 class='name'>Deniset</h5>
              <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
              <span>
                                I got the boots to work outside and pull weeds
                                down by my lake and work in the garden. They are
                                true to size,{" "}
                <em>
                                    extremely comfortable and{" "}
                  <i>keep my feet dry.</i>
                </em>{" "}
                                They are easy to clean and I love the style.
                                Definitely worth the money.
              </span>
              <a href='https://www.hisea.com/women-ankle-height-garden-boots-xsx30w.html'>
                                View Review
              </a>
            </section>
            <section>
              <h5 class='name'>Ambert</h5>
              <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
              <span>
                                These boots are really nice. Very high quality
                                and well made.{" "}
                <em>
                                    They keep my feet <i>warm and dry</i> while
                                    outside in the rain.
                </em>{" "}
                                They have decent grip on the bottom to help not
                                slide. They clean easily as well. I would
                                recommend it.
              </span>
              <a href='https://www.hisea.com/womens-rubber-mud-boots-xsx22w.html'>
                                View Review
              </a>
            </section>
            <section>
              <h5 class='name'>Jared S.</h5>
              <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
              <span>
                                These boots are extremely comfortable! The
                                cushions in the inside sole feels like walking
                                on a soft pillow. I love the strap on the back
                                for adjusting the tightness. I can wear my jeans
                                inside without bunching up while walking.I am a
                                farmer so I'm out in the pasture and muck most
                                of my day.{" "}
                <em>
                                    These boots clean up very nicely. They seem
                                    to be very durable and{" "}
                  <i>keep my feet warm and dry.</i>
                </em>
              </span>
              <a href='https://www.hisea.com/mens-rubber-working-boots-with-eva-midsoles-xsx26.html'>
                                View Review
              </a>
            </section>
            <section>
              <h5 class='name'>MJ</h5>
              <SimpleImage src='https://www.hisea.com/media/wysiwyg/convenpage/start.png' />
              <span>
                                These boots are insulated and 100% waterproof
                                and breathable and light weight and
                                slip-resistant. Also, they are a very good
                                looking pair of boots. The stretch-fit top
                                bindings the calves to{" "}
                <em>
                  <i>keep warmth</i> in and cold out.
                </em>{" "}
                                My husband loves these boots. He would highly
                                recommend them and I think they are a good buy!
              </span>
              <a href='https://www.hisea.com/mens-rubber-working-boots-with-eva-midsoles-xsx26.html'>
                                View Review
              </a>
            </section>
          </section>
        )}
      </div>

      <div className={classes.adventure}>
        <div className={classes.adventureContent}>
          <h2>NEVER STOP YOUR PACE TO THE ADVENTURE</h2>
          <h6>SUPER DURAbLE &amp; 100% WATERPROOF</h6>
          <a href='https://www.hisea.com/mens-boots/'>shop mens</a>
          <a href='https://www.hisea.com/womens-boots/'>
                        shop womens
          </a>
          <a href='https://www.hisea.com/kids-boots/'>shop kids</a>
        </div>
      </div>

      <div className={classes.otherFeatures}>
        <h2>OTHER PRODUCT FEATURES</h2>
        <div className={classes.featureContainer}>
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures1.svg'
            alt='max stretch'
          />
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures2.svg'
            alt='waterproof'
          />
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures3.svg'
            alt='keep warm'
          />
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures4.svg'
            alt='breathable'
          />
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures5.svg'
            alt='easy clean'
          />
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures6.svg'
            alt='shock resistance'
          />
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures7.svg'
            alt='anti-slip'
          />
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures8.svg'
            alt='toe protection'
          />
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures9.svg'
            alt='insulated'
          />
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures10.svg'
            alt='stealthiness'
          />
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures11.svg'
            alt='lightweight'
          />
          <SimpleImage
            src='https://www.hisea.com/media/wysiwyg/convenpage/ProductFeatures12.svg'
            alt='odor free'
          />
        </div>
      </div>
    </div>
  )
}

export default KeepDryAndWarmPage
